import React from "react";
import { Colors } from "./Colors";
// Settings Constants

export const DEFAULT_SETTINGS = {
  cableSide: "R",
  volume: "High",
  brightness: "High",
  patientLanguage: "Chinese",
  systemLanguage: "Chinese",
  inRoomSittingUpAudioOn: false,
  inRoomLeavingAudioOn: true,
  alertsOn: true,
  stirringOn: true,
  sittingUpOn: true,
  leavingOn: true,
  immobileOn: true,
  repositionOn: true,
  wanderingOn: true,
  repositionTimerMin: 120,
  wanderingTimerMin: 15,
  hrMin: 40,
  hrMax: 130,
  rrMin: 8,
  rrMax: 32,
  vitalSignOn: true,
};

export const Reposition = "Reposition";
export const Wandering = "Wandering";

// Box Constants

export const BoxEventType = {
  BoxState: "BoxState",
  PatientState: "PatientState",
  RepositionRequired: "RepositionRequired",
  BoxTransmissionStatus: "BoxTransmissionStatus",
  SystemConnectionStatus: "SystemConnectionStatus",
  PadConnectionStatus: "PadConnectionStatus",
  NurseMode: "NurseMode",
};

export const BoxEventValue = {
  // -- BoxState
  PowerOn: "PowerOn",
  NoTransmission: "NoTransmission",
  // -- PatientState
  NotOnBed: "NotOnBed",
  OnBed: "OnBed",
  Return: "Return",
  Immobilization: "Immobilization",
  Stirring: "Stirring",
  SittingUp: "SittingUp",
  Leaving: "Leaving",
  OutOfBed: "OutOfBed",
  NoCheckIn: "NoCheckIn",
  Wandering: "Wandering",
  // -- RepositionRequired
  On: "On",
  Off: "Off",
  // -- BoxTransmissionStatus
  Normal: "Normal",
  Poor: "Poor",
  None: "None",
  // -- PadConnectionStatus
  PadConnected: "PadConnected",
  Disconnected: "Disconnected",
  ResDisconnected: "ResDisconnected",
  PadNeedsReplacement: "PadNeedsReplacement",
  PadDamaged: "PadDamaged",
  PadNormal: "PadNormal",
  SensorUpgrade: "SensorUpgrade",
  // -- SystemConnectionStatus
  // Normal : 'Normal',
  DataHubNone: "DataHubNone",
  // -- NurseMode
  NurseModeOn: "NurseModeOn",
  // On: 'On',
  // Off: 'Off',
  Reset: "Reset",
  NurseModeResponse: "NurseModeResponse",
  NoEvent: "NoEvent",
};

export const BoxEventCode = {
  // -- BoxState
  PowerOn: "300101",
  NoTransmission: "300102",
  // -- PatientState
  NotOnBed: "200101",
  OnBedSupine: "200102",
  Immobilization: "200103",
  Stirring: "200104",
  SittingUp: "200105",
  LeavingOut: "200106",
  OutOfBed: "200107",
  Return: "200108",
  Wandering: "200111",
  OnBedLeftLateral: "200112",
  OnBedRightLateral: "200113",
  OnBedSittingUp: "200114",
  LeavingBack: "200115",

  // -- SensorValue
  PressureDuration: "200401",
  AveragePressure: "200501",
  AveragePressureLevel: "200502",
  HBR: "200601",
  HBRSilence: "200601s",
  // -- RepositionRequired
  RepositionRequired: "200201", // on
  RepositionDetected: "200202", // off
  // -- PadConnectionStatus
  PadConnected: "100101",
  PadDisconnected: "100102",
  PadNeedsReplacement: "100103",
  PadDamaged: "100104",
  PadNormal: "100105",
  ResDisconnected: "100106",
  SensorUpgrade: "100109",
  // -- NurseMode
  NurseModeOn: "100601",
  Reset: "100601",
  NurseModeResponse: "100602",
  // -- NoEvent
  NoEvent: "000000",
};

// Other

export const BodyStyle = {
  Black: "Black",
  None: "None",
};

// Pressure Record Constants

export const pressureDurationColors = [
  Colors.Over_1,
  Colors.Over_5,
  Colors.Over_10,
  Colors.Over_30,
  Colors.Over_60,
  Colors.Over_90,
  Colors.Over_120,
];
export const pressureLevelColors = [
  Colors.Level_1,
  Colors.Level_2,
  Colors.Level_3,
];
export const pressureDurationTexts = ["1", "5", "10", "30", "60", "90", "120"];
export const pressureLevelTexts = ["Level 1", "Level 2", "Level 3"];

export const MARKS = {
  1440: { label: <span>24:00</span>, style: { color: Colors.Focus } },
  1320: { label: <span>22:00</span>, style: { color: Colors.Focus } },
  1200: { label: <span>20:00</span>, style: { color: Colors.Focus } },
  1080: { label: <span>18:00</span>, style: { color: Colors.Focus } },
  960: { label: <span>16:00</span>, style: { color: Colors.Focus } },
  840: { label: <span>14:00</span>, style: { color: Colors.Focus } },
  720: { label: <span>12:00</span>, style: { color: Colors.Focus } },
  600: { label: <span>10:00</span>, style: { color: Colors.Focus } },
  480: { label: <span>8:00</span>, style: { color: Colors.Focus } },
  360: { label: <span>6:00</span>, style: { color: Colors.Focus } },
  240: { label: <span>4:00</span>, style: { color: Colors.Focus } },
  120: { label: <span>2:00</span>, style: { color: Colors.Focus } },
  0: { label: <span>0:00</span>, style: { color: Colors.Focus } },
};

export const PATIENT_STATE = "PatientState";
export const REPOSITION_REQUIRED = "RepositionRequired";

export const VolumeLevelValueMap = {
  1: "Off",
  2: "Low",
  3: "Medium",
  4: "High",
  5: "Highest",
};

export const VolumeValueLevelMap = {
  Off: "1",
  Low: "2",
  Medium: "3",
  High: "4",
  Highest: "5",
};

export const BrightnessLevelValueMap = {
  1: "Low",
  2: "Mid",
  3: "High",
};

export const BrightnessValueLevelMap = {
  Low: "1",
  Mid: "2",
  High: "3",
};

export const RoleMap = {
  0: "Level 1",
  1: "Level 2",
  2: "Level 3",
};

export const StatusMap = {
  0: "Disable",
  1: "Enabled",
};

export const AudioAlertEvents = ["200106", "200107", "200111", "200115"];

export const AudioRepositionEvents = ["200103", "200201"];
